// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { CAlarm_abstract } from './../abstract/SagaSchema/CAlarm_abstract';
export class CAlarm extends CAlarm_abstract {}
